// import { useHighlightParts } from '@/hooks/use-highlight-parts';
// import { KText } from '@/ui-library/components';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';

export const HighlightedTooltipText = ({ text, highlight, ...rest }) => {
  // const parts = useHighlightParts(text, highlight);

  return (
    <TruncatedTextWithTooltip
      text={text}
      {...rest}
      toolTipVariant="default"
      // renderText={() =>
      //   parts?.map((part, i) => (
      //     <KText
      //       as="span"
      //       key={i}
      //       {...rest}
      //       size={part.highlight && 'sm-semi-bold'}
      //       color="secondary-900"
      //       bg={part.highlight ? 'pastel-6-light' : 'transparent'}
      //       p={part.highlight ? '2px' : '0'}
      //       borderRadius={part.highlight ? '4px' : '0'}
      //     >
      //       {part.text}
      //     </KText>
      //   ))
      // }
      color="secondary-900"
      tooltipProps={{ color: 'white' }}
    />
  );
};
